var exports = {
  "k": "xf0b3b88a--d58230--container",
};

module.exports = exports;
